import { setErrorHandler } from '@coverright/data-access/apollo-clients';
import {
  getIsAgent,
  getIsAgentManager,
  getIsCSR,
  getIsDeveloper,
  getIsSuperAdmin,
  initKeycloak,
  keycloakConfig,
} from '@coverright/shared/keycloak';
import Keycloak from 'keycloak-js';
import { environment } from './environments/environment';
import { enqueueSnackbar } from 'notistack';
import { initSentry } from '@coverright/shared/config';

const CALENDAR_OPERATIONS = new Set([
  'calendarEvents',
  'createCalendarEvent',
  'updateCalendarEvent',
  'deleteCalendarEvent',
  'respondToCalendarEvent',
]);

export async function initApp() {
  const keycloak = await initKeycloak({
    onLoad: 'login-required',
  }, new Keycloak({
    ...keycloakConfig,
    clientId: 'admin-frontend'
  }));

  //todo change to advisor
  const canPass = getIsCSR(keycloak) || getIsSuperAdmin(keycloak) || getIsAgent(keycloak) || getIsDeveloper(keycloak) || getIsAgentManager(keycloak);

  if (!canPass) {
    // eslint-disable-next-line no-restricted-globals
    const result  = confirm('You are not authorized. Sign out?')
    if (result) {
      keycloak.logout();
    } else {
      throw new Error('Wrong role');
    }
  }

  if (environment.production) {
    initSentry(environment.production, 'https://a835ed5d5244220f2692bb6fee1dfaa2@o4507526906511360.ingest.us.sentry.io/4508296668577792', [/^https:\/\/admin\.coverright\.com/])
  }

  const res = await fetch(
    `${environment.userFlowRestUrl}/getAdminSettings`,
    { headers: { Authorization: `Bearer ${keycloak.token}` } }
  ).then((data) => {
    if (data.status === 200) {
      return data.json();
    }
  })

  if (!res?.settings) {
    sessionStorage.setItem('settings', '{}');
  } else {
    sessionStorage.setItem('settings', JSON.stringify(res.settings));
  }

  sessionStorage.setItem('settings', '{}');

  setErrorHandler(({ operation, response, graphQLErrors, networkError }: any) => {
    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path, extensions }: any) => {
          if (message.indexOf('The field at path') < 0) {
            if (CALENDAR_OPERATIONS.has(operation.operationName)) return;
            switch (extensions?.status) {
              case '422': {
              }; break;
              default: {
                console.error(
                  `Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`,
                )
                enqueueSnackbar(message, {variant: 'error'});
              }
            }
          }
        }
      );
  });
}
